import axios from 'axios';
// axios.defaults.baseURL = 'https://xxjy.camh.org.cn/'; 
axios.defaults.baseURL = 'https://rps.camh.org.cn/'; 
// axios.defaults.baseURL = 'http://192.168.249.176/'; 
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 请求拦截器
axios.interceptors.request.use((config) => {
    if(JSON.parse(localStorage.getItem("User"))){
        config.headers['token'] = JSON.parse(localStorage.getItem("User")).userinfo.token;
    }
    return config
}, (error) => {
    // 错误抛到业务代码
    error.data = {}
    error.data.msg = '服务器异常，请联系管理员！'
    return Promise.resolve(error)
})

axios.interceptors.response.use(res => {
    if (res.data.code > 200) {
        console.log(res.data.msg)
    }
    return res;
}, error => {
    if (error.response.status >= 400) {
        if(error.response.status==401){
            window.location.href = "/#/Login"
        }else{
            console.log("网络错误")
        }
    }
    return Promise.reject(error);
});
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data).then(response => {
            resolve(response);
        }, err => {
            reject(err);
        });
    });
}